import { $getEditor } from 'lexical';

// Force any pending updates to be flushed by reading state
export default function $flushEditorUpdates() {
  $getEditor().read(() => {});
}
